import React, { useState } from 'react';
import {
  Image,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tooltip,
} from '@chakra-ui/react';

interface ShortcutProps {
  image: string;
  width?: string;
  text: string;
  link: string;
  alignSelf?: string;
}

export const Shortcut: React.FC<ShortcutProps> = ({
  image = '',
  width = '80px',
  text = '',
  alignSelf = 'center',
  link,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onChangeOpenState = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Popover
        placement="left"
        closeOnBlur={false}
        onClose={onChangeOpenState}
        isOpen={isOpen}
        matchWidth
      >
        <PopoverTrigger>
          <Link href={link} alignSelf={alignSelf}>
            <Image
              src={image}
              width={width}
              height={width}
              onMouseEnter={onChangeOpenState}
              alignSelf={alignSelf}
            />
          </Link>
        </PopoverTrigger>
        <PopoverContent color="white" bg="gray" borderColor="gray">
          <PopoverArrow bg="gray" />
          <PopoverCloseButton />
          <PopoverBody>{text}</PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
};
